<div class="container-fluid col-12 col-md-10">
    <button appPreventDoubleClick class="floating-button" mat-fab color="primary" (throttledClick)="save(false);">
        <mat-icon>save</mat-icon>
    </button>

    <div class="container-fluid mt-4 ">
        <div class="border rounded-1 background-light p-3">
            <!-- <h5 class="card-header">Localisation</h5> -->

            <div class="row">
                <h2 class="col text-center fw-bold"> Localisation</h2>
            </div>

            <div class="row">

                <mat-form-field class="col">
                    <mat-label>X (L93)</mat-label>
                    <input matInput placeholder="X (L93)" type="number" [(ngModel)]="model.Position.L93X" [formControl]="IsX2FarControl">
                    <mat-error *ngIf="IsX2FarControl.hasError('pattern')">
                        Format erroné. 6 chiffres uniquement !
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="col">
                    <mat-label>Y (L93)</mat-label>
                    <input matInput placeholder="Y (L93)" type="number" [(ngModel)]="model.Position.L93Y" [formControl]="IsY2FarControl">
                    <mat-error *ngIf="IsY2FarControl.hasError('pattern')">
                        Format erroné. 7 chiffres uniquement !
                    </mat-error>
                </mat-form-field>
            </div>

        </div>
    </div>

    <div class="container-fluid mt-4 ">
        <div class="border rounded-1 background-light p-3">
            <!-- <h5 class="card-header">Mesures</h5> -->
            <div class="row">
                <h2 class="col text-center fw-bold"> Mesures</h2>
            </div>
            <div class="row">

                <mat-form-field class="col-12 col-sm-6 col-md-4">
                    <mat-label>Mode de prélèvement</mat-label>
                    <mat-select placeholder="Mode de prélèvement" [(ngModel)]="model.Methode" required>
                        <mat-option *ngFor="let m of ModePrelevementList; let i = index" [value]="i + 1">
                            <span>{{m}} </span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="col-12 col-sm-6 col-md-4">
                    <mat-label>Hauteur d'eau moyenne estimée (m)</mat-label>
                    <input matInput placeholder="Hauteur d'eau moyenne estimée (m)" type="number" [(ngModel)]="model.HauteurMoyenneEauEstimee">
                </mat-form-field>
                <mat-form-field class="col-12 col-sm-6 col-md-4">
                    <mat-label>Profondeur de prélèvement (m)</mat-label>
                    <input matInput placeholder="Profondeur de prélèvement (m)" type="number" [(ngModel)]="model.Profondeur">
                </mat-form-field>
                <mat-form-field class="col-12 col-sm-6 col-md-4">
                    <mat-label>Nombre de flacons</mat-label>
                    <input matInput placeholder="Nombre de flacons" type="number" [(ngModel)]="model.NombreFlacons">
                </mat-form-field>
                <mat-form-field class="col-12 col-sm-6 col-md-4">
                    <mat-label>Température glacière (°C)</mat-label>
                    <input matInput placeholder="Température glacière (°C)" type="number" [(ngModel)]="model.TemperatureGlaciere">
                </mat-form-field>
                <mat-form-field class="col-12 col-sm-6 col-md-4">
                    <mat-label>Largeur totale du cours d’eau (pour débit) (m)</mat-label>
                    <input matInput placeholder="Largeur totale du cours d’eau (pour débit) (m)" type="number" [(ngModel)]="model.DistanceMesure">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="container-fluid mt-4 ">
        <div class="border rounded-1 background-light p-3">

            <div class="row g-0">

                <!-- <h5 class="d-flex align-items-center m-0 col-auto">Mesure de débit</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Mesure de débit</h2>
                </div>
                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openWaterMesureBox()">
                    <mat-icon>add</mat-icon>
                </button>
                <!-- <button appPreventDoubleClick throttleTime="200" mat-icon-button color="primary" (throttledClick)="removeMesure()">
                        <mat-icon>remove</mat-icon>
                    </button> -->
            </div>

            <div class="row mt-3 justify-content-center">
                <span> Débit: {{computeWaterFlow() | number: '1.1-4'}} m³/s </span>
            </div>
            <div class="row mt-3 ">
                <div *ngFor="let mesure of model.Measures; let i = index" class="col-12 col-sm-6 col-md-4 col-xl-3 py-1">
                    <div class="col">
                        <div class="border rounded p-3">
                            <div class="row">

                                <mat-form-field class="col-6">
                                    <mat-label>Distance (m)</mat-label>
                                    <input matInput placeholder="Distance (m)" type="number" [(ngModel)]="mesure.Distance" disabled="true">
                                </mat-form-field>
                                <mat-form-field class="col-6">
                                    <mat-label>Profondeur (cm)</mat-label>
                                    <input matInput placeholder="Profondeur (cm)" type="number" [(ngModel)]="mesure.Profondeur" disabled="true">
                                </mat-form-field>
                            </div>
                            <div class="row">
                                <mat-form-field class="col-6">
                                    <mat-label>V02P (m/s)</mat-label>
                                    <input matInput placeholder="V02P (m/s)" type="number" [(ngModel)]="mesure.V02P" disabled="true">
                                </mat-form-field>
                                <mat-form-field class="col-6">
                                    <mat-label>V04P (m/s)</mat-label>
                                    <input matInput placeholder="V04P (m/s)" type="number" [(ngModel)]="mesure.V04P" disabled="true">
                                </mat-form-field>
                            </div>
                            <div class="row justify-content-center">
                                <mat-form-field class="col-6">
                                    <mat-label>V08P (m/s)</mat-label>
                                    <input matInput placeholder="V08P (m/s)" type="number" [(ngModel)]="mesure.V08P" disabled="true">
                                </mat-form-field>
                                <div class="col-6 p-0 d-flex justify-content-center">

                                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openWaterMesureBox(mesure)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeMeasure(mesure)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>